import React from 'react';
import styled from 'styled-components';

const NButton = styled.button`
  cursor: pointer;
  height: 48px;
  padding-left: 16px;
  padding-right: 16px;
  -webkit-tap-highlight-color: transparent;
`;
NButton.displayName = 'NButton';

export default class Button extends React.Component {
  render() {
    return (
      <NButton { ...this.props } />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Button/Button.js